// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__21vK5","image":"App_image__tvUSX"};